import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section
      data-testid="not-found-page"
      className="min-h-[60vh] flex items-center justify-center px-6"
    >
      <div className="max-w-xl text-center">
        <div className="font-mono text-xs text-brand-olive tracking-[0.24em]">
          ERROR · 404
        </div>
        <h1 className="font-display mt-6 text-4xl sm:text-5xl text-brand-deep font-light leading-tight">
          That signal isn't here.
        </h1>
        <p className="mt-5 text-brand-muted font-light">
          The page you're looking for may have been moved or doesn't exist.
        </p>
        <Link
          to="/"
          data-testid="not-found-home-link"
          className="mt-10 inline-flex items-center gap-2 bg-brand-olive hover:bg-brand-hover text-brand-cream px-6 py-3 text-sm font-medium transition-colors"
        >
          Back to home
        </Link>
      </div>
    </section>
  );
}
